import { connect } from 'react-redux';
import MaintenanceOrderFlowEditComponent from '../components/MaintenanceOrderFlowEditComponent.jsx';

const mapStateToProps = (state) => ({
	step1Class: state.getIn(['maintenanceOrderReducer', 'step1Class']),
	step2Class: state.getIn(['maintenanceOrderReducer', 'step2Class']),
	step1Display: state.getIn(['maintenanceOrderReducer', 'step1Display']),
	step2Display: state.getIn(['maintenanceOrderReducer', 'step2Display']),
})

const mapDispatchToProps = (dispatch) => ({
})

const MaintenanceOrderFlowEditContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MaintenanceOrderFlowEditComponent)

export default MaintenanceOrderFlowEditContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceOrderFlowEditContainer.jsx